import { createSelector } from 'reselect';

const selectGlobalAgentNetTypes = (state: any) => state.globalAgentNetTypes;


export const selectGlobalAgentNetTypesCurrentItem = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.current);

export const selectGlobalAgentNetTypesListItems = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalAgentNetTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalAgentNetTypesQueryItems = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.query);

export const selectGlobalAgentNetTypesCreatedItem = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.create);

export const selectGlobalAgentNetTypesUpdatedItem = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.update);

export const selectGlobalAgentNetTypesReadItem = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.read);

export const selectGlobalAgentNetTypesDeletedItem = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.delete);

export const selectGlobalAgentNetTypesSearchedItems = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.search);

export const selectGlobalAgentNetTypesItemsCount = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.count);

export const selectGlobalAgentNetTypesItemsFilter = createSelector([selectGlobalAgentNetTypes], (globalAgentNetTypes) => globalAgentNetTypes.filter);